/* Dlook hero slider.
 *
 * Horizontal swipe/slide animation.
 * Slides move from right to left instead of cross-fading.
 * Autoplay, dots, pause on hover, reduced-motion and touch swipe supported.
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  var ACTIVE_DOT = ['w-14', 'bg-white/40'];
  var IDLE_DOT = ['w-[6px]', 'bg-white/70', 'hover:bg-white'];

  function initHero(section) {
    if (section.dataset.dlookHeroReady === 'true') return;
    section.dataset.dlookHeroReady = 'true';

    var slides = Array.prototype.slice.call(
      section.querySelectorAll('[data-dlook-slide]')
    );

    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(
      section.querySelectorAll('[data-dlook-hero-dot]')
    );

    var duration = Number(section.dataset.autoplay) || 6000;
    var index = 0;
    var timer = null;
    var paused = false;

    /* Prepare slides */
    slides.forEach(function (slide, i) {
      slide.style.transition = 'transform 700ms cubic-bezier(0.22, 1, 0.36, 1)';
      slide.style.willChange = 'transform';

      slide.classList.remove(
        'opacity-0',
        'opacity-50',
        'opacity-100',
        'pointer-events-none'
      );

      slide.style.opacity = '1';
      slide.style.pointerEvents = i === 0 ? 'auto' : 'none';
      slide.style.transform = i === 0 ? 'translateX(0)' : 'translateX(100%)';

      slide.setAttribute('aria-hidden', String(i !== 0));
    });

    function show(next, direction) {
      if (next === index) return;

      var current = index;

      /*
       * direction:
       *  1  = next slide comes from right
       * -1  = previous slide comes from left
       */
      if (!direction) {
        direction = next > current ? 1 : -1;
      }

      var incoming = slides[next];
      var outgoing = slides[current];

      /* Put incoming slide in its starting position */
      incoming.style.transition = 'none';
      incoming.style.transform =
        direction === 1 ? 'translateX(100%)' : 'translateX(-100%)';
      incoming.style.opacity = '1';
      incoming.style.pointerEvents = 'auto';

      incoming.setAttribute('aria-hidden', 'false');
      outgoing.setAttribute('aria-hidden', 'true');

      /* Force browser to register starting position */
      void incoming.offsetWidth;

      /* Animate both slides */
      incoming.style.transition =
        'transform 700ms cubic-bezier(0.22, 1, 0.36, 1)';
      outgoing.style.transition =
        'transform 700ms cubic-bezier(0.22, 1, 0.36, 1)';

      incoming.style.transform = 'translateX(0)';
      outgoing.style.transform =
        direction === 1 ? 'translateX(-100%)' : 'translateX(100%)';

      /* Disable interaction on outgoing slide */
      outgoing.style.pointerEvents = 'none';

      /* Update dots */
      dots.forEach(function (dot, i) {
        var isActive = i === next;

        dot.setAttribute('aria-current', String(isActive));

        ACTIVE_DOT.forEach(function (c) {
          dot.classList.toggle(c, isActive);
        });

        IDLE_DOT.forEach(function (c) {
          dot.classList.toggle(c, !isActive);
        });

        dot.innerHTML = '';

        if (isActive && !reduceMotion.matches) {
          var fill = document.createElement('span');

          fill.setAttribute('data-dlook-hero-fill', '');
          fill.className = 'block h-full w-full origin-left bg-white';

          fill.style.animation =
            'fillBar ' +
            duration +
            'ms cubic-bezier(0.65, 0, 0.35, 1) forwards';

          fill.style.willChange = 'transform';

          dot.appendChild(fill);
        } else if (isActive) {
          var solid = document.createElement('span');

          solid.className = 'block h-full w-full bg-white';

          dot.appendChild(solid);
        }
      });

      index = next;
    }

    function advance() {
      show((index + 1) % slides.length, 1);
    }

    function start() {
      stop();

      if (reduceMotion.matches) return;

      timer = window.setInterval(function () {
        if (!paused && !document.hidden) {
          advance();
        }
      }, duration);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
      }

      timer = null;
    }

    /* Pause on hover */
    section.addEventListener('mouseenter', function () {
      paused = true;

      var fill = section.querySelector('[data-dlook-hero-fill]');

      if (fill) {
        fill.style.animationPlayState = 'paused';
      }
    });

    section.addEventListener('mouseleave', function () {
      paused = false;

      var fill = section.querySelector('[data-dlook-hero-fill]');

      if (fill) {
        fill.style.animationPlayState = 'running';
      }
    });

    /* Dot navigation */
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var direction = i > index ? 1 : -1;

        show(i, direction);
        start();
      });
    });

    /* Mobile touch swipe */
    var touchStartX = 0;
    var touchStartY = 0;
    var touchEndX = 0;
    var touchEndY = 0;

    section.addEventListener(
      'touchstart',
      function (event) {
        if (!event.touches || !event.touches.length) return;

        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        touchEndX = touchStartX;
        touchEndY = touchStartY;
      },
      { passive: true }
    );

    section.addEventListener(
      'touchmove',
      function (event) {
        if (!event.touches || !event.touches.length) return;

        touchEndX = event.touches[0].clientX;
        touchEndY = event.touches[0].clientY;
      },
      { passive: true }
    );

    section.addEventListener(
      'touchend',
      function () {
        var diffX = touchEndX - touchStartX;
        var diffY = touchEndY - touchStartY;

        /* Ignore vertical swipes */
        if (Math.abs(diffX) < Math.abs(diffY)) return;

        /* Ignore tiny movements */
        if (Math.abs(diffX) < 50) return;

        if (diffX < 0) {
          /* Swipe left → next */
          show((index + 1) % slides.length, 1);
        } else {
          /* Swipe right → previous */
          show(
            (index - 1 + slides.length) % slides.length,
            -1
          );
        }

        start();
      },
      { passive: true }
    );

    /* Reduced motion */
    reduceMotion.addEventListener('change', function () {
      start();
    });

    start();
  }

  function initAll() {
    document
      .querySelectorAll('[data-dlook-hero]')
      .forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Shopify theme editor */
  document.addEventListener(
    'shopify:section:load',
    initAll
  );
})();